import { View } from 'foundations-components/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import HsocFeatureTableSkeleton, { DEFAULT_SKELETON_COLUMN_COUNT } from './HsocFeatureTableSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
/*
 * The feature table's loading state as a standalone card. Mirrors the
 * CardWrapper in HsocFeatureTable so the loaded table and this placeholder share
 * a footprint. Small enough to sit in the initial bundle, so the public
 * code-split loading fallback can reserve the table's space immediately without
 * pulling in the full HsocFeatureTable.
 */
const HsocFeatureTableLoadingCard = ({
  columnCount = DEFAULT_SKELETON_COLUMN_COUNT
}) => /*#__PURE__*/_jsx(View, {
  paddingBlockEnd: "600",
  children: /*#__PURE__*/_jsx(CardWrapper, {
    maxInlineSize: "1200px",
    margin: "auto",
    borderRadius: "400",
    children: /*#__PURE__*/_jsx(HsocFeatureTableSkeleton, {
      columnCount: columnCount
    })
  })
});
export default HsocFeatureTableLoadingCard;